import { ColumnTypes } from '@makyoapp/makyo-sdk/models/Table'

/**
 * filterUniqueBy - Filters an array of objects to remove duplicates based on a specified property.
 * @param {T[]} arr - The array of objects to filter.
 * @param {keyof T} prop - The property to use for uniqueness comparison.
 * @returns {T[]} A new array with duplicates removed.
 */
export function filterUniqueBy<T>(arr: T[], prop: keyof T): T[] {
  const set = new Set()

  return arr.filter((item) => {
    const value = item[prop]

    if (set.has(value)) {
      return false
    }

    set.add(value)
    return true
  })
}

export const getActiveLanguage = (appID: string | undefined) => {
  if (!appID) return
  const activeLanguages = JSON.parse(localStorage.getItem(`activeLanguages:${appID}`) || '{}')
  return activeLanguages[appID] as string | undefined
}

/**
 * Helper function to get the default value for a given column type
 */
export function getDefaultColumnValue(type: ColumnTypes): any {
  switch (type) {
    case ColumnTypes.Image:
    case ColumnTypes.Attachment:
    case ColumnTypes.URL:
    case ColumnTypes.Text:
    case ColumnTypes.Email:
    case ColumnTypes.Phone:
    case ColumnTypes.Color:
    case ColumnTypes.Address:
    case ColumnTypes.RichText:
    case ColumnTypes.Template:
    case ColumnTypes.Barcode:
    case ColumnTypes.QRCode:
    case ColumnTypes.Slug:
      return ''
    case ColumnTypes.Array:
    case ColumnTypes.ImageArray:
    case ColumnTypes.Connection:
    case ColumnTypes.Lookup:
      return []
    case ColumnTypes.Number:
    case ColumnTypes.Math:
      return null
    case ColumnTypes.Rating:
      return 0
    case ColumnTypes.Boolean:
      return false
    case ColumnTypes.DateTime:
      return null
    case ColumnTypes.Coordinate:
      return { Lat: 0, Lon: 0 }
    case ColumnTypes.Function:
    case ColumnTypes.SingleCell:
      return null
  }
}
